import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import StatusBadge from './StatusBadge';

const PilgrimTableRow = ({ pilgrim, isSelected, onSelect, currentLanguage = 'fr' }) => {
  const navigate = useNavigate();
  const [showActions, setShowActions] = useState(false);

  const labels = {
    fr: {
      viewProfile: 'Voir le profil',
      editPilgrim: 'Modifier',
      manageDocuments: 'Documents',
      viewHistory: 'Historique',
      sendMessage: 'Envoyer un message',
      actions: 'Actions'
    },
    ar: {
      viewProfile: 'عرض الملف',
      editPilgrim: 'تعديل',
      manageDocuments: 'الوثائق',
      viewHistory: 'السجل',
      sendMessage: 'إرسال رسالة',
      actions: 'الإجراءات'
    }
  };

  const handleViewProfile = () => {
    navigate('/pilgrim-profile', { state: { pilgrimId: pilgrim?.id } });
  };

  const getProgressColor = (progress) => {
    if (progress >= 80) return 'bg-success';
    if (progress >= 50) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-smooth">
      <td className="p-4">
        <Checkbox
          checked={isSelected}
          onChange={(e) => onSelect(pilgrim?.id, e?.target?.checked)}
        />
      </td>
      <td className="p-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
            <Image
              src={pilgrim?.avatar}
              alt={pilgrim?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="min-w-0">
            <p className="font-medium text-foreground truncate">{pilgrim?.name}</p>
            <p className="caption text-muted-foreground truncate">{pilgrim?.passportNumber}</p>
          </div>
        </div>
      </td>
      <td className="p-4">
        <p className="text-sm text-foreground">{pilgrim?.phone}</p>
        <p className="caption text-muted-foreground truncate">{pilgrim?.email}</p>
      </td>
      <td className="p-4">
        <p className="text-sm text-foreground truncate">{pilgrim?.group}</p>
      </td>
      <td className="p-4">
        <StatusBadge status={pilgrim?.visaStatus} type="visa" currentLanguage={currentLanguage} />
      </td>
      <td className="p-4">
        <StatusBadge status={pilgrim?.documentStatus} type="document" currentLanguage={currentLanguage} />
      </td>
      <td className="p-4">
        <StatusBadge status={pilgrim?.paymentStatus} type="payment" currentLanguage={currentLanguage} />
      </td>
      <td className="p-4">
        <div className="flex items-center gap-2">
          <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
            <div 
              className={`h-full ${getProgressColor(pilgrim?.caseProgress)} transition-smooth`}
              style={{ width: `${pilgrim?.caseProgress}%` }}
            />
          </div>
          <span className="caption text-muted-foreground data-text whitespace-nowrap">
            {pilgrim?.caseProgress}%
          </span>
        </div>
      </td>
      <td className="p-4">
        <div className="flex items-center gap-2 justify-end">
          <Button
            variant="ghost"
            size="icon"
            iconName="Eye"
            onClick={handleViewProfile}
          />
          <div className="relative">
            <Button
              variant="ghost"
              size="icon"
              iconName="MoreVertical"
              onClick={() => setShowActions(!showActions)}
            />
            {showActions && (
              <div className="absolute right-0 top-full mt-1 w-48 bg-popover border border-border rounded-md shadow-warm-lg z-50 overflow-hidden">
                <button
                  onClick={handleViewProfile}
                  className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted transition-smooth"
                >
                  <Icon name="User" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-foreground">{labels?.[currentLanguage]?.viewProfile}</span>
                </button>
                <button
                  onClick={() => setShowActions(false)}
                  className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted transition-smooth"
                >
                  <Icon name="Edit" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-foreground">{labels?.[currentLanguage]?.editPilgrim}</span>
                </button>
                <button
                  onClick={() => navigate('/document-management')}
                  className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted transition-smooth"
                >
                  <Icon name="FolderOpen" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-foreground">{labels?.[currentLanguage]?.manageDocuments}</span>
                </button>
                <button
                  onClick={() => setShowActions(false)}
                  className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted transition-smooth"
                >
                  <Icon name="History" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-foreground">{labels?.[currentLanguage]?.viewHistory}</span>
                </button>
                <button
                  onClick={() => navigate('/communication-center')}
                  className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted transition-smooth border-t border-border"
                >
                  <Icon name="MessageSquare" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-foreground">{labels?.[currentLanguage]?.sendMessage}</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </td>
    </tr>
  );
};

export default PilgrimTableRow;